import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { MenuIcon, XIcon } from "lucide-react";
import { navLinks } from "../data/content";
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return <header className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color] duration-300 ease-out border-b ${scrolled || open ? "bg-ink/90 backdrop-blur-md border-line" : "bg-transparent border-transparent"}`} data-id="element-177" data-mp="lpo7xfms2iw">
      <nav className="mx-auto flex h-20 max-w-7xl items-center justify-between px-6 lg:px-10" aria-label="Navigation principale" data-id="element-178" data-mp="1pxrqbr9y4qv0">
        <a href="#top" className="flex items-baseline gap-2" data-id="element-179" data-mp="1kz85xvb03n4r">
          <span className="font-display text-2xl italic text-cream" data-id="element-180" data-mp="9p93ryclpr1f">Pardus Dei</span>
          <span className="hidden text-[11px] text-stone sm:inline" data-id="element-181" data-mp="en18jsych7n1">Chatterie Bengal</span>
        </a>

        <ul className="hidden items-center gap-9 lg:flex" data-id="element-182" data-mp="jm448msfq1ic">
          {navLinks.map(l => <li key={l.href} data-id="element-183" data-mp="om9z0bu0444n">
              <a href={l.href} className="text-sm text-stone transition-colors duration-150 hover:text-cream" data-id="element-184" data-mp="okfdavawo7zi">
                {l.label}
              </a>
            </li>)}
        </ul>

        <a href="#contact" className="hidden rounded-full bg-sage px-5 py-2.5 text-sm font-medium text-ink transition-colors duration-150 hover:bg-cream lg:inline-flex" data-id="element-185" data-mp="3s3ib0f21s9rg">
          Nous contacter
        </a>

        <button type="button" className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-line text-cream lg:hidden" onClick={() => setOpen(o => !o)} aria-expanded={open} aria-label={open ? "Fermer le menu" : "Ouvrir le menu"} data-id="element-186" data-mp="5oz0wuk3vgqs">
          {open ? <XIcon className="h-5 w-5" data-id="element-187" data-mp="2wcgdgf3pssxl" /> : <MenuIcon className="h-5 w-5" data-id="element-188" data-mp="2wb5dyrhay7ca" />}
        </button>
      </nav>

      <AnimatePresence data-id="element-189" data-mp="3b0talfejghto">
        {open && <motion.div initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="border-t border-line bg-ink px-6 pb-8 pt-4 lg:hidden" data-id="element-190" data-mp="3b0jnbzkvooro">
            <ul className="flex flex-col" data-id="element-191" data-mp="2df5ekvlzw1io">
              {navLinks.map(l => <li key={l.href} data-id="element-192" data-mp="2sbd3284frp3r">
                  <a href={l.href} onClick={() => setOpen(false)} className="block border-b border-line py-4 font-display text-2xl text-cream" data-id="element-193" data-mp="2s88pik52zh0f">
                    {l.label}
                  </a>
                </li>)}
            </ul>
            <a href="#contact" onClick={() => setOpen(false)} className="mt-6 inline-flex w-full justify-center rounded-full bg-sage px-5 py-3 text-sm font-medium text-ink" data-id="element-194" data-mp="a497r5zqxr7h">
              Nous contacter
            </a>
          </motion.div>}
      </AnimatePresence>
    </header>;
}